module.exports = __webpack_public_path__ + "static/media/ic-roadmap.fda6ce2a.svg";